import { PhasrMonitoredRulesDetailsPanelController } from '../controller/PhasrMonitoredRulesDetailsPanelController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { GeneralMonitoredRule } from '../types';

export class PhasrMonitoredRulesDetailsPanelComponent extends BaseWebComponentElement {
  public generalDetails: GeneralMonitoredRule;
  public monitoredRuleDescription: string;
  public ruleName: string;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: PhasrMonitoredRulesDetailsPanelController,
    });
  }
}
